<script type="ts">
  import { gameState, store } from "../store";

  $: disabled = $gameState.draft?.players.length < 2;

  const onStartPlaying = () => {
    if (!disabled) {
      store.update((state) => {
        return [$gameState.draft, ...state];
      });
      gameState.update((_) => {
        return {
          currentGame: $gameState.draft.id,
          draft: undefined,
        };
      });
    }
  };
</script>

<div class="text-center">
  <button
    class="mt-4 btn btn-primary"
    class:btn-disabled={disabled}
    on:click={onStartPlaying}>Spiel starten</button
  >
</div>
